/**
 * PACMAN GAME CONSTANTS
 * Costanti centralizzate per il gioco Pacman
 */

export const GAME_CONFIG = {
  // Dimensioni
  CELL_SIZE: 20,
  DEFAULT_WIDTH: 760,
  DEFAULT_HEIGHT: 620,
  
  // Velocità
  PACMAN_SPEED: 2,
  GHOST_SPEED: 1.5,
  FRIGHTENED_SPEED: 1,
  
  // Timing
  POWER_UP_DURATION: 8000,
  FPS: 60,
  
  // Punteggi
  DOT_SCORE: 10,
  POWER_PELLET_SCORE: 50,
  GHOST_SCORE: 200,
  
  // Gameplay
  INITIAL_LIVES: 3,
  INITIAL_LEVEL: 1
} as const

export const COLORS = {
  // Entità
  PACMAN: '#FFFF00',
  WALL: '#0033CC',
  WALL_HIGHLIGHT: '#0044FF',
  DOT: '#FFB897',
  POWER_PELLET: '#FFB897',
  BACKGROUND: '#000',
  
  // Fantasmi
  BLINKY: '#FF0000',    // Rosso
  PINKY: '#FFB8FF',     // Rosa
  INKY: '#00FFFF',      // Ciano
  CLYDE: '#FFB847',     // Arancione
  FRIGHTENED: '#0000FF', // Blu
  FRIGHTENED_FLASH: '#FFFFFF',
  
  // UI
  TEXT: '#FFFFFF',
  GAME_OVER: '#FF0000',
  WIN: '#00FF00',
  GHOST_HOUSE: '#FF69B4'
} as const

export const GHOST_SPAWN_POSITIONS = [
  { x: 360, y: 220, color: COLORS.BLINKY },
  { x: 380, y: 220, color: COLORS.PINKY },
  { x: 400, y: 220, color: COLORS.INKY },
  { x: 420, y: 220, color: COLORS.CLYDE }
] as const

export const PACMAN_SPAWN = {
  x: 380,
  y: 460
} as const
